/*
  Re-checks the monthly country rotation in the browser, because Shopify can serve a cached
  page rendered last month. The passport always starts at the current calendar month:
  slot 1 = this month ("Shipping now"), slot 2 = next month ("Next up"), the rest hidden,
  and a finished month moves to the end. Works on any [data-c-schedule] root that contains
  the JSON printed by snippets/c-country-schedule.liquid:
    [data-c-stamp][data-handle]  re-ordered to the rotation; .is-collected on slots 1-2,
                                 .is-current on slot 1; [data-c-stamp-num] gets the slot number
    [data-c-now-name] / [data-c-next-name]  country names
    [data-c-now-img] / [data-c-next-img]    box images (the stamp, with .is-stamp, when there is none)
    [data-c-count]  number of revealed countries
*/
(() => {
  const REVEALED = 2;
  const thisMonth = new Date().getMonth() + 1;

  const apply = (root) => {
    const script = root.querySelector('[data-c-schedule-data]');
    if (!script) return;
    let countries;
    try {
      countries = JSON.parse(script.textContent).sort((a, b) => a.month - b.month);
    } catch (e) {
      return;
    }
    if (!countries.length) return;

    // This month onwards first, then the months already past this year
    const order = [...countries.filter((c) => c.month >= thisMonth), ...countries.filter((c) => c.month < thisMonth)];
    const current = order[0];
    const next = order[1];

    const stamps = [...root.querySelectorAll('[data-c-stamp][data-handle]')];
    const byHandle = new Map(stamps.map((stamp) => [stamp.dataset.handle, stamp]));
    const list = stamps[0]?.parentElement;
    const tail = list ? [...list.children].filter((el) => !byHandle.has(el.dataset.handle)) : [];
    order.forEach((country, i) => {
      const stamp = byHandle.get(country.handle);
      if (!stamp) return;
      list.appendChild(stamp);
      stamp.classList.toggle('is-collected', i < REVEALED);
      stamp.classList.toggle('is-current', i === 0);
      stamp.querySelectorAll('[data-c-stamp-num]').forEach((el) => {
        el.textContent = String(i + 1);
      });
    });
    // Unscheduled empty slots stay after the countries
    tail.forEach((el) => list.appendChild(el));

    root.querySelectorAll('[data-c-count]').forEach((el) => {
      el.textContent = String(Math.min(REVEALED, order.length));
    });

    const setCountry = (country, nameSel, imgSel) => {
      if (!country) return;
      root.querySelectorAll(nameSel).forEach((el) => {
        el.textContent = country.name;
      });
      // Box photo, or the country's stamp when the month has no box photo yet
      const src = country.box || country.stamp;
      if (!src) return;
      root.querySelectorAll(imgSel).forEach((img) => {
        img.classList.toggle('is-stamp', !country.box);
        if (img.getAttribute('src') === src) return;
        img.removeAttribute('srcset');
        img.src = src;
        img.alt = country.name;
      });
    };
    setCountry(current, '[data-c-now-name]', '[data-c-now-img]');
    setCountry(next, '[data-c-next-name]', '[data-c-next-img]');
    root.querySelectorAll('[data-c-next-wrap]').forEach((el) => {
      el.hidden = !next;
    });
  };

  const init = () => document.querySelectorAll('[data-c-schedule]').forEach(apply);
  init();
  document.addEventListener('shopify:section:load', init);
})();
